exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._13I8-SdN67yGhnvuz0mRJw{z-index:10000000!important}", ""]);
// Exports
exports.locals = {
	"layerRoot": "_13I8-SdN67yGhnvuz0mRJw"
};